import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linkify',
    standalone: false
})
export class LinkifyPipe implements PipeTransform {
    transform(text: string): string {
        if (!text) return text;

        const regex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
        return text.replace(regex, (match, title, url) => {
            return `<a href="${url}" target="_blank">${title}</a>`;
        });
    }
}
